import yup from '../../../config/yup';

export const blackboardReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('blackboardReader'),
  delayedRead: yup.boolean(),
  parameterizedBy: yup.string(),
  connectionKey: yup.string(),
  format: yup.string(),
  properties: yup.object().shape({
    key: yup.string().transform((value) => value.trim()),
    secret: yup.string().transform((value) => value.trim()),
    rootUrl: yup.string().transform((value) => value.trim()),
    path: yup
      .string()
      .required('Path is required')

      .transform((value) => value.trim()),
  }),
});
